import React from 'react'
import { useState, useEffect } from 'react';

const useCarousel = () => {
    const [firstCarousel, setFirstCarousel] = useState([]);
    const [secondCarousel, setSecondCarousel] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCarousel = async () => {
        try {
            const response = await fetch('https://backend.indianjewelryish.com/api/all-carousels');
            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json();
            // console.log('Carousel:', data);

            setFirstCarousel(data.first_carousal || []);
            setSecondCarousel(data.second_carousal || []);
            setError(null);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCarousel();
    }, []);

    return { firstCarousel, secondCarousel, loading, error };
};

export default useCarousel;